import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface SettingsTabProps {
    name: string;
    icon: any;
    isActive: boolean;
    onClick: () => void;
}

const SettingsTab: React.FC<SettingsTabProps> = ({ name, icon, isActive, onClick }) => (
    <button
        className={`flex items-center w-full py-3 px-4 rounded-lg transition-all duration-200 ${
            isActive
                ? 'bg-neutral-400 dark:bg-neutral-700 dark:text-neutral-100 shadow-lg'
                : 'hover:bg-neutral-600/50 dark:text-neutral-300 dark:hover:bg-neutral-700/50 dark:hover:text-neutral-100'
        }`}
        onClick={onClick}
    >
        <FontAwesomeIcon icon={icon} className={`h-5 w-5 mr-3 ${isActive ? 'text-cyan-600' : ''}`} />
        <span className="text-sm font-medium">{name}</span>
    </button>
);

export default SettingsTab;
